(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-default/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-default/assets/javascripts/status.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sportDefault = svs.themes.sportDefault || {};

  svs.themes.sportDefault.isStopped = function(status) {
    return _.contains([25, 26, 27, 28, 29, 30], status);
  };

  svs.themes.sportDefault.isFinished = function(status) {
    return _.contains([31, 32, 33, 41], status);
  };

  svs.themes.sportDefault.isEnded = function(status) {
    return (
      svs.themes.sportDefault.isFinished(status) ||
      svs.themes.sportDefault.isStopped(status)
    );
  };

  svs.themes.sportDefault.isLive = function(status) {
    return (status >= 1 && status <= 22) || (status >= 34 && status <= 40);
  };

  svs.themes.sportDefault.hasStarted = function(status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };

  svs.themes.sportDefault.getStatusText = function(options) {
    var text = '',
      status;

    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });

    status = options.statusId;

    if (!_.contains([25, 29, 31, 32, 41], status) && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    } else {
      text = 'SLUT';
    }

    return text;
  };

  svs.themes.sportDefault.isFullTimeOrPassed = function(status, options) {
    options = _.extend(
      {
        includeFullTime: true,
        includePauses: true,
        includeFinished: true
      },
      options
    );

    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };
})(svs);

 })(window);